import React from 'react';
import PropTypes from 'prop-types';
// import { colors } from '../../../css';

function SupplierFeatureThree(props) {
  const { height, width, iconColor, backgroundColor } = props;

  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 800 450"
      height={height}
      width={width}
    >
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="305.6 168.21 291.03 153.64 218.16 226.51 190.04 198.39 175.47 212.96 218.18 255.67 232.75 241.1 232.73 241.07 305.6 168.21"
      />
      <path
        fill={backgroundColor}
        d="M196.18,365.72l-.44-1.83L152.21,181.72c-.24-1.49-.71-3.52-1.27-5.87-1.89-8.08-5.05-21.61-3.79-34.33a60.69,60.69,0,0,1,23.47-42.05A67.06,67.06,0,0,1,221.46,86c.35,0,40.52,5.13,50.43,48.77l.4,1.76L233.5,146.94l-.45-1.86c-3.61-14.77-17.57-16.51-17.71-16.52a22.49,22.49,0,0,0-25.54,19l-.11.82c-2.58,19.86,17.56,24.49,18.41,24.68.27.08,13.89,3.95,40.83,2.36l26.76-1.27,11,42.76,28.74,120.27Zm21.66-276.4a63.44,63.44,0,0,0-44.91,13.1,57,57,0,0,0-22.05,39.46c-1.2,12.11,1.88,25.26,3.71,33.12.59,2.52,1.06,4.52,1.29,6L199,361.2l112-26.76L283.08,217.85l-10.26-39.78-23.7,1.12c-27.65,1.63-41.37-2.3-41.94-2.47a33.43,33.43,0,0,1-11.59-5.47c-5.26-3.91-11.2-11.13-9.61-23.32l.11-.88a26.25,26.25,0,0,1,29.73-22.21c.1,0,15.45,1.92,20.35,17.5l31.65-8.51c-9.94-39.38-45.32-44-46.84-44.13C219.93,89.54,218.88,89.42,217.84,89.32Z"
      />
      <rect
        fill={backgroundColor}
        x="186.71"
        y="234.89"
        width="82.41"
        height="3.83"
        transform="translate(-48.79 59.44) rotate(-13.44)"
      />
      <rect
        fill={backgroundColor}
        x="194.62"
        y="270.21"
        width="44.95"
        height="3.83"
        transform="translate(-57.29 57.89) rotate(-13.44)"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="200.07 297.19 197.85 287.8 277.84 268.69 280.06 278.08 200.07 297.19"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="207.6 328.72 205.38 319.33 285.37 300.21 287.59 309.6 207.6 328.72"
      />
      <rect
        fill={backgroundColor}
        x="201.51"
        y="296.83"
        width="82.41"
        height="3.83"
        transform="translate(-62.77 64.58) rotate(-13.44)"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="474.19 168.21 459.63 153.64 386.76 226.51 358.64 198.39 344.07 212.96 386.78 255.67 401.35 241.1 401.32 241.07 474.19 168.21"
      />
      <path
        fill={backgroundColor}
        d="M364.77,365.72l-.43-1.83L320.8,181.72c-.23-1.49-.71-3.52-1.26-5.87-1.89-8.08-5.05-21.61-3.79-34.33a60.69,60.69,0,0,1,23.47-42.05A67.06,67.06,0,0,1,390.06,86c.35,0,40.52,5.13,50.43,48.77l.4,1.76L402.1,146.94l-.46-1.86c-3.6-14.77-17.56-16.51-17.7-16.52a22.49,22.49,0,0,0-25.54,19l-.11.82c-2.58,19.86,17.55,24.49,18.41,24.68.27.08,13.89,3.95,40.82,2.36l26.77-1.27,11,42.76,28.75,120.27Zm21.66-276.4a63.43,63.43,0,0,0-44.9,13.1,57,57,0,0,0-22,39.46c-1.2,12.11,1.87,25.26,3.71,33.12.59,2.52,1.06,4.52,1.29,6l43.07,180.2,112-26.76L451.68,217.85l-10.26-39.78-23.7,1.12c-27.65,1.63-41.38-2.3-41.94-2.47a33.35,33.35,0,0,1-11.59-5.47c-5.26-3.91-11.2-11.13-9.61-23.32l.11-.88a26.25,26.25,0,0,1,29.72-22.21c.11,0,15.46,1.92,20.36,17.5l31.65-8.51c-9.94-39.38-45.32-44-46.85-44.13C388.53,89.54,387.48,89.42,386.43,89.32Z"
      />
      <rect
        fill={backgroundColor}
        x="355.3"
        y="234.89"
        width="82.41"
        height="3.83"
        transform="translate(-44.17 98.62) rotate(-13.44)"
      />
      <rect
        fill={backgroundColor}
        x="363.22"
        y="270.21"
        width="44.95"
        height="3.83"
        transform="translate(-52.68 97.07) rotate(-13.44)"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="368.67 297.19 366.45 287.8 446.44 268.69 448.66 278.08 368.67 297.19"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="376.19 328.72 373.98 319.33 453.97 300.21 456.19 309.6 376.19 328.72"
      />
      <rect
        fill={backgroundColor}
        x="370.11"
        y="296.83"
        width="82.41"
        height="3.83"
        transform="translate(-58.16 103.75) rotate(-13.44)"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="643.27 168.21 628.71 153.64 555.84 226.51 527.72 198.39 513.15 212.96 555.86 255.67 570.43 241.1 570.4 241.07 643.27 168.21"
      />
      <path
        fill={backgroundColor}
        d="M533.85,365.72l-.43-1.83L489.88,181.72c-.23-1.49-.71-3.52-1.26-5.87-1.89-8.08-5.05-21.61-3.79-34.33A60.69,60.69,0,0,1,508.3,99.47,67.06,67.06,0,0,1,559.14,86c.35,0,40.52,5.13,50.43,48.77l.4,1.76-38.79,10.43-.45-1.86c-3.61-14.77-17.57-16.51-17.71-16.52a22.49,22.49,0,0,0-25.54,19l-.11.82c-2.58,19.86,17.55,24.49,18.41,24.68.27.08,13.89,3.95,40.82,2.36l26.77-1.27,11,42.76,28.75,120.27Zm21.66-276.4a63.43,63.43,0,0,0-44.9,13.1,57,57,0,0,0-22.05,39.46c-1.2,12.11,1.87,25.26,3.71,33.12.59,2.52,1.06,4.52,1.29,6l43.07,180.2,112-26.76L620.76,217.85,610.5,178.07l-23.7,1.12c-27.65,1.63-41.38-2.3-41.94-2.47a33.35,33.35,0,0,1-11.59-5.47c-5.26-3.91-11.2-11.13-9.61-23.32l.11-.88a26.25,26.25,0,0,1,29.72-22.21c.11,0,15.46,1.92,20.36,17.5l31.65-8.51c-9.94-39.38-45.32-44-46.85-44.13C557.61,89.54,556.56,89.42,555.51,89.32Z"
      />
      <rect
        fill={backgroundColor}
        x="524.38"
        y="234.89"
        width="82.41"
        height="3.83"
        transform="translate(-39.54 137.9) rotate(-13.44)"
      />
      <rect
        fill={backgroundColor}
        x="532.3"
        y="270.21"
        width="44.95"
        height="3.83"
        transform="translate(-48.05 136.36) rotate(-13.44)"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="537.75 297.19 535.53 287.8 615.52 268.69 617.74 278.08 537.75 297.19"
      />
      <polygon
        fill={iconColor}
        opacity="0.4"
        points="545.27 328.72 543.06 319.33 623.05 300.21 625.27 309.6 545.27 328.72"
      />
      <rect
        fill={backgroundColor}
        x="539.19"
        y="296.83"
        width="82.41"
        height="3.83"
        transform="translate(-53.53 143.04) rotate(-13.44)"
      />
    </svg>
  );
}

SupplierFeatureThree.propTypes = {
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  iconColor: PropTypes.string,
  backgroundColor: PropTypes.string
};

SupplierFeatureThree.defaultProps = {
  width: 800,
  height: 450,
  iconColor: '#52b7b0',
  backgroundColor: '#333232'
};

export default SupplierFeatureThree;
